import { Link } from "react-router-dom";
import { IDS } from "@/lib/testIds";

export function BrandMark({ to = "/", subtitle = "Cierge Design Studio" }) {
  return (
    <Link
      to={to}
      data-testid={IDS.landingBrand}
      className="group inline-flex items-center gap-3 no-underline"
    >
      <span className="flex h-9 w-9 items-center justify-center rounded-[7px] bg-ink text-stone-soft">
        <span className="font-serif text-[17px] leading-none tracking-tight">K</span>
      </span>
      <span className="flex flex-col leading-tight">
        <span className="font-serif text-[17px] font-medium text-ink tracking-tight">
          KATLAS
        </span>
        <span className="text-[11px] uppercase tracking-[0.18em] text-muted">
          {subtitle}
        </span>
      </span>
    </Link>
  );
}
